import {registerTemplateGraphNode} from "#template/template-node/register"
import {pointGeometryAttributeSetLike, pointGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {pointGeometryAttributeLike} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {PointGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {PointGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {ProductOperatorPairParameters} from "#template/nodes/geometry-graph/attribute-set/product-operator/geometry-product-operator-pair-node"
import {
    GeometryProductOperatorPairNode,
    productOperatorPairParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/product-operator/geometry-product-operator-pair-node"

export type PointGeometryProductOperatorPointGeometryPointGeometryInputParameters = ProductOperatorPairParameters<
    PointGeometryAttributeLikeNode,
    PointGeometryAttributeSetLikeNode,
    PointGeometryAttributeLikeNode,
    PointGeometryAttributeSetLikeNode
>

const definition: TemplateNodeDefinition<PointGeometryProductOperatorPointGeometryPointGeometryInputParameters> = {
    nodeClass: "PointGeometryProductOperatorPointGeometryPointGeometryInput",
    validation: {
        parameters: productOperatorPairParametersSchema(
            pointGeometryAttributeLike,
            pointGeometryAttributeSetLike,
            pointGeometryAttributeLike,
            pointGeometryAttributeSetLike,
        ),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryProductOperatorPointGeometryPointGeometryInput
    extends GeometryProductOperatorPairNode<
        0,
        PointGeometryAttributeLikeNode,
        PointGeometryAttributeSetLikeNode,
        PointGeometryAttributeLikeNode,
        PointGeometryAttributeSetLikeNode
    >
    implements PointGeometryAttributeSetLikeNode
{
    get [pointGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }

    protected override get outputIndexingDim(): 0 {
        return 0
    }
}
